import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/SinglePicker.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/SinglePicker.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('Popup', {
    attrs: {
      "position": "right",
      "width": "100%",
      "show-mask": _vm.showMask
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": 80
    }
  }, [_vm._l(_vm.faults, function (item, index) {
    return _c('div', {
      key: index
    }, [_c('group', [_c(__unplugin_components_0, {
      attrs: {
        "title": i18n.tc("623"),
        "placeholder": i18n.tc("624"),
        "value": item.breakdownPatternCategoryId + '',
        "data": _vm.breakDown
      },
      on: {
        "input": function ($event) {
          item.breakdownPatternCategoryId = $event;
        },
        "on-change": function ($event) {
          return _vm.getBreakdownPatternList($event, item);
        }
      }
    })], 1), _c('group', [_c(__unplugin_components_1, {
      attrs: {
        "title": i18n.tc("625"),
        "placeholder": i18n.tc("626"),
        "value": item.breakdownPatternId + '',
        "data": item.breakDownList || []
      },
      on: {
        "input": function ($event) {
          item.breakdownPatternId = $event;
        },
        "on-change": function ($event) {
          return _vm.setItemDesc($event, item);
        }
      }
    })], 1), _c('group', [_c('Cell', {
      attrs: {
        "title": i18n.tc("232"),
        "value": item.descri
      }
    })], 1)], 1);
  }), _c('div', {
    staticClass: "add-part font-size-h3-large",
    on: {
      "click": _vm.addFault
    }
  }, [_vm._v(i18n.tc("627"))]), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('div', {
    staticClass: "btn-body"
  }, [_c('x-button', {
    staticClass: "main-color no-border-radius",
    attrs: {
      "type": "default"
    },
    nativeOn: {
      "click": function ($event) {
        _vm.currValue = false;
      }
    }
  }, [_vm._v(" " + i18n.tc("11") + " ")])], 1), _c('div', {
    staticClass: "btn-body"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v(i18n.tc("235"))])], 1)])], 2)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };